export default __webpack_public_path__ + "static/media/kz.8ad451f1.svg";